import React, { useState } from "react";
import PinPad from "../pos/components/PinPad";
import { useI18n } from "../i18n";

/**
 * Choosing a till PIN: four digits, then the same four again.
 *
 * Used where a PIN is still the shipped default — the register's unlock and
 * the dashboard's first-sign-in screen. `onSave(pin)` resolves to nothing when
 * it worked or to the message to show when the server refused the PIN.
 */
const NewPinForm = ({ onSave }) => {
  const { t } = useI18n();
  const [first, setFirst] = useState(null);
  const [notice, setNotice] = useState("");

  const submit = async (pin) => {
    if (!first) {
      setFirst(pin);
      setNotice("");
      return null;
    }

    if (pin !== first) {
      setFirst(null);
      setNotice(t("auth.credentials.pinMismatch"));
      return null;
    }

    const problem = await onSave(pin);

    if (problem) {
      // The pad starts over for the next try, so the reason is shown here:
      // the pad's own message would go with it
      setFirst(null);
      setNotice(problem);
    }

    return null;
  };

  return (
    <div className="flex flex-col items-center">
      <p className="mt-1 max-w-xs text-center text-sm text-slate-300">
        {first ? t("auth.credentials.pinConfirm") : t("auth.credentials.pinIntro")}
      </p>
      {notice && <p className="mt-2 text-sm text-amber-300 text-center">{notice}</p>}
      {/* A fresh pad for each step, so the dots start empty */}
      <PinPad key={first ? "confirm" : "enter"} onSubmit={submit} />
    </div>
  );
};

export default NewPinForm;
